import { render } from "./IBProgram.vue?vue&type=template&id=599b5874&scoped=true"
import script from "./IBProgram.vue?vue&type=script&lang=js"
export * from "./IBProgram.vue?vue&type=script&lang=js"

import "./IBProgram.vue?vue&type=style&index=0&id=599b5874&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599b5874"]])

export default __exports__